<template>
  <div>
    <navbar />
    <main>
      <section class="relative w-full h-full py-40 min-h-screen">
        <div
          class="absolute top-0 w-full h-full bg-blueGray-800 bg-no-repeat bg-cover"
          :style="`background-image: url('${authBg}');`"
        ></div>
        <router-view />
        <footer-small absolute />
      </section>
    </main>
  </div>
</template>

<script>
import Navbar from "@/components/Shared/Navbars/AuthNavbar.vue";
import FooterSmall from "@/components/Shared/Footers/FooterSmall.vue";
import authBg from "@/assets/imgs/pattern-randomized.svg";

export default {
  components: {
    Navbar,
    FooterSmall
  },
  data() {
    return {
      authBg
    };
  }
};
</script>
